import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { HttpStatusCode } from "axios";
import { login_API } from "../../../api/controller/authController";
import { useApplicationContext } from "../../../context/ApplicationContext";
import useErrorHandler from "../../../api/errorHandler/useErrorHandler";
import { useNavigate } from "react-router-dom";
import { toggleTheme, initializeTheme } from "../../../utils/themeUtils";
import {
  ModulePath,
  Severity,
  VerificationStatus,
  VerificationType,
} from "../../../constant/ApplicationVariables";
import validator from "validator";
import { useState } from "react";
import { useEffect } from "react";
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  useTheme,
} from "@mui/material";
import {
  AutoAwesome,
  Visibility,
  VisibilityOff,
  WavingHand,
} from "@mui/icons-material";
import { font } from "../../../styles/font";
import ApplicationLogo from "../../layout/ApplicationLogo";
import { amber } from "@mui/material/colors";
import LeftSection from "../container/leftSection";
import MainContainer, { AuthCardComponent, FormHeader } from "../container";
import { LuMoon, LuSun, LuZap } from "react-icons/lu";
import dayjs from "dayjs";

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  margin: "auto",
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.paper,
  boxShadow: "none",
  [theme.breakpoints.up("sm")]: {},
}));

export default function LoginContainer() {
  const {
    globalSnackbar,
    setGLobalSnackBar,
    handleSnackbar,
    handleStoreUserData,
    profileDetails,
    setProfileDetails,
    accountVerificationType,
    setAccountVerificationType,
    setCurrentFolderData,
    handleRedirectAfterAuthentication,
  } = useApplicationContext();
  const errorHandler = useErrorHandler();
  const navigate = useNavigate();
  const theme = useTheme();

  const [loginData, setLoginData] = useState(null);
  const [error, setError] = useState(null);

  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    validateInputs(); // Call your validation function
  };

  const handleClickOpen = () => {
    setOpen(true);
    navigate(ModulePath.forgotPassword);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeValue = (event) => {
    const { name, value } = event.target;

    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateInputs = () => {
    let isValid = true;
    const errorObject = {};

    if (!loginData?.email || !validator.isEmail(loginData?.email)) {
      errorObject.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!loginData?.password || loginData?.password?.length < 6) {
      errorObject.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    setError(errorObject);

    return isValid && handleContinue();
  };

  const handleContinue = async () => {
    try {
      setLoading(true);
      // let body = {
      //     email: "testing@floxpad.com",
      //     password: "p@ssword"
      // }

      let body = {
        email: loginData.email,
        password: loginData.password,
      };

      const response = await login_API(body);

      if (response) {
        errorHandler(response);
      }

      if (response.status === HttpStatusCode.Ok) {
        // setCurrentFolderData(null);
        // localStorage.setItem("access-token", response.data.authToken);
        // localStorage.setItem("profileDetails", JSON.stringify(response.data));
        // setProfileDetails(response.data);

        handleStoreUserData(response.data);

        if (response.data.status === VerificationStatus.Verified) {
          // handleStoreUserData(response.data);
          handleSnackbar("User signed in successfully", Severity.success);
          setTimeout(() => {
            // navigate(ModulePath.projects);
            handleRedirectAfterAuthentication(response.data?.role);
            // navigate(0);
          }, 1100);
        }

        if (response.data.status === VerificationStatus.Unverified) {
          // setAccountVerificationType(VerificationType.Account);
          // handleStoreUserData(response.data);
          handleSnackbar("Please verify your account", Severity.info);
          setTimeout(() => {
            navigate(ModulePath.verifyAccount, {
              state: {
                email: loginData.email,
                type: VerificationType.Account,
                fromPath: ModulePath.login,
              },
            });
          }, 1100);
        }

        if (response.data.status === VerificationStatus.Invited) {
          // setAccountVerificationType(VerificationType.Account);
          // handleStoreUserData(response.data);
          handleSnackbar(
            "Please set a password for your account",
            Severity.info
          );
          setTimeout(() => {
            navigate(ModulePath.resetPassword, {
              state: {
                email: loginData.email,
                type: VerificationType.ForgotPassword,
                fromPath: ModulePath.login,
              },
            });
          }, 1100);
        }
      }
    } catch (error) {
      console.log(error, error?.message, "login errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

    // Initialize theme on mount
  useEffect(() => {
    initializeTheme();
  }, []);

  // Theme toggle handler
  const handleThemeToggle = () => {
    toggleTheme();
  };

  return (
    <Box className=" min-h-screen flex flex-col lg:flex-row relative">
      <div className="flex absolute right-5 top-5">
        {" "}
        <div
          className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan to-emerald flex items-center justify-center shadow-lg shadow-cyan/30 group-hover:shadow-cyan/50 transition-shadow duration-300"
          onClick={handleThemeToggle}
        >
          <LuMoon className="w-5 h-5 block dark:hidden text-primary-foreground " />
            {/* Sun – dark mode */}
                      <LuSun
                        className="w-5 h-5 hidden dark:block text-primary-foreground"
                      />
        </div>
      </div>
      <MainContainer>
        <>
          {/* Logo */}
          <div className="lg:hidden mb-8 text-center">
            <Link to="/" className="inline-flex items-center gap-2 group">
              <div className="relative">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan to-emerald flex items-center justify-center shadow-lg shadow-cyan/30">
                  <LuZap className="w-5 h-5 text-primary-foreground" />
                </div>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-cyan to-emerald blur-xl opacity-50" />
              </div>
              <span className="text-3xl font-extrabold tracking-tight text-black dark:text-white">
                Flox
                <span className="inline-block text-gradient relative">
                  pad
                  <span className="block h-[3px] w-[90%] mx-auto bg-gradient-to-r from-cyan-400 to-emerald-400 rounded-full mt-[-1px] ml-3"></span>
                </span>
              </span>
            </Link>
          </div>
          {/* Form Card */}
          <div className="glass-card p-8 bg-background">
            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-2  text-black dark:text-white">
                Sign in to your account
              </h2>
              <p className="text-muted-foreground">
                Enter your credentials to access your dashboard
              </p>
            </div>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Email Input */}
              <FormControl fullWidth>
                <FormLabel
                  htmlFor="email"
                  className="text-black dark:text-white"
                >
                  Email
                </FormLabel>
                <TextField
                  size="medium"
                  // label="Email"
                  error={error?.email && error?.email}
                  helperText={error?.email && error?.email}
                  id="email"
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  autoComplete="email"
                  autoFocus
                  required
                  fullWidth
                  variant="outlined"
                  color={error?.email ? "error" : "primary"}
                  value={loginData?.email}
                  onChange={handleChangeValue}
                />
              </FormControl>
              {/* Password Input */}
              <FormControl fullWidth>
                <FormLabel
                  htmlFor="password"
                  className="text-black dark:text-white"
                >
                  Password
                </FormLabel>
                <TextField
                  size="medium"
                  // label="Password"
                  error={error?.password && error?.password}
                  helperText={error?.password && error?.password}
                  name="password"
                  placeholder="••••••  "
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  autoFocus
                  required
                  fullWidth
                  border="text-black dark:text-white"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="text-black dark:text-white "
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  color={error?.password ? "error" : "primary"}
                  value={loginData?.password}
                  onChange={handleChangeValue}
                />

                <Box className="flex items-center justify-end gap-2 mt ">
                  <Typography
                    color={theme.palette.text.ternary}
                    fontSize={font.size.fs_5}
                    className="flex items-center justify-center gap-1 "
                  >
                    Forgot Password?{" "}
                    <Typography
                      color={theme.palette.text.primary}
                      fontSize={"inherit"}
                      fontWeight="bold"
                      className="underline cursor-pointer "
                      onClick={() => navigate(ModulePath.forgotPassword)}
                    >
                      Click here
                    </Typography>
                  </Typography>
                </Box>
              </FormControl>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                className="!text-white dark:!text-black"
                sx={{
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: "10px",
                  background: "linear-gradient(90deg, #06b6d4, #10b981)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #0891b2, #059669)",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Login Now"
                )}
              </Button>

              {/* Remember Me & Forgot Password */}

              {/* Submit Button */}
            </form>

            {/* Create Account Link */}
            {/* <div className="mt-8 pt-6 border-t border-border/50 text-center">
              <p className="text-sm text-muted-foreground">
                Don't have an account?{" "}
                <Link href={ModulePath.register} className="text-gradient">
                  Create an account
                </Link>
              </p>
            </div> */}
          </div>
        </>

        <p className="mt-8 text-center text-xs text-muted-foreground">
          @{dayjs().year()} Floxpad. All rights are reserved.
        </p>
      </MainContainer>
    </Box>
  );
}
